// utils/cookie.js

/**
 * Получить значение куки по ключу
 */
export const getCookie = (name) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
};

/**
 * Установить куки с параметрами по умолчанию
 */
export const setCookie = (name, value, options = {}) => {
  const cookieOptions = {
    path: '/',
    SameSite: 'Lax',
    ...options
  };

  if (cookieOptions.expires instanceof Date) {
    cookieOptions.expires = cookieOptions.expires.toUTCString();
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  for (const [key, val] of Object.entries(cookieOptions)) {
    updatedCookie += `; ${key}`;
    if (val !== true) updatedCookie += `=${val}`;
  }

  document.cookie = updatedCookie;
};